export default {
  // buttons
  YES: 'Yes',
  OK: 'OK',
  NO: 'No',
  NOW: 'Now',
  OR: 'OR',
  LATER: 'Later',
  SUBMIT: 'Submit',
  CALL: 'Call',
  DONE: 'Done',
  REMOVE: 'Remove',
  GET_OTP: 'Get Code',
  GO_BACK: 'Go back',
  RETRY: 'Retry',
  GET_EMAIL_OTP: 'Get security code by Email',
  GET_MOBILE_OTP: 'Get security code by Text',
  LOGIN: 'Sign In',
  VERIFY_YOUR_PHONE: 'Verify Your Phone',
  CHECK_IN: 'Check In',
  CHECK_IN_QR: 'Check in with a QR code',
  ENTER_TABLE_NUMBER: 'Enter My Table Number',
  SCAN_TABLE_CODE: 'Scan My Table Code',
  LEAVE_TABLE: 'Exit check',
  LOADING: 'Loading',
  RESEND_OTP: 'Resend Code',
  RESEND_IN: 'Resend in',
  RESEND: 'Resend',
  SECONDS: 'seconds',
  BACK: 'Back',
  SAVE_CHANGES: 'Save changes',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  YES_CONTINUE: 'Yes, continue',
  TRY_AGAIN: 'Try Again',
  SMS: 'SMS',
  EMAIL: 'Email',
  SIGN_UP: 'Sign up',
  RESET_PASSWORD: 'Reset Password',
  SUBMITING: 'Submiting',
  SPLIT_EQUALY: 'Split Equaly',
  SELECT_BY_ITEMS: 'Select Items To Pay',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  SAVE: 'Save',
  SKIP: 'Skip',
  VERIFY: 'Verify',
  CONTINUE: 'Continue',
  TEXT_RECEIPT: 'Text Receipt',
  EMAIL_RECEIPT: 'Email Receipt',
  NO_RECEIPT: 'No Receipt',
  YOUR_RECEIPT: 'Your Receipt',
  VIEW_RECEIPT: 'View Receipt',
  GENERATE_OTP: 'Generate Code',
  PAY_NOW: 'Pay Now',
  ADD_TIP: ' ADD TIP',
  TIP_ADD: 'Add Tip',
  CONFIRMATION: 'Confirmation',
  TABLE: 'Table',
  RESTAURANT: 'Restaurant',
  SPOT_NUMBER: 'Spot Number',
  I_AM_HERE: 'I AM HERE',
  CHECK_IN_WITH_CODE: 'Check in with a 7-digit code',
  CALS: 'CAL',
  CALS_SEPARATOR: '-',
  CALS_SEPARATOR_START: '',
  CALS_SEPARATOR_END: '',
  CALS_FROM: 'From',
  READ_MORE: 'more',
  MORE: '..more',
  // label
  ENTER_EMAILID_MESSAGE: 'Please enter the email you use to sign in to OneDine.',
  SENDING_OTP: 'Sending',
  PLEASE_SELECT_OPTION: 'Please select one of the following options',
  // profile pages names
  PROFILE_SETTING_TITLE: 'Profile Settings',
  MANAGE_PAYMENT_METHODS_TITLE: 'Manage payment methods',
  LOYALTY_ACCOUNT_TITLE: 'Loyalty Accounts',

  // Form Label
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  NICK_NAME: 'Order Nickname',
  USER_NAME: 'User Name',
  PHONE_NUMBER: 'Phone Number',
  EMAIL_ADDRESS: 'Email Address',
  EMAIL_ADDRESS_PROFILE: 'Email Address',
  ENTER_USERNAME_EMAIL: 'Username',
  ENTER_PASSWORD: 'Password',
  ENTER_OTP: 'Enter Code',
  CURRENT_PASSWORD: 'Current Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  COUNTRY_CODE: 'Country Code',
  ENTER_ACCOUNT_NUMBER: 'Enter your Account Number',
  ENTER_EMAIL_ADDRESS: 'Enter your email address',
  ENTER_FIRST_NAME: 'First Name',
  ENTER_LAST_NAME: 'Last Name',
  FULL_NAME: 'Full Name',
  ENTER_DESIRED_USERNAME: 'Username',
  ENTER_CONFIRM_PASSWORD: 'Confirm Password',
  ENTER_THE_OTP: 'Verification Code',
  EMAILS: 'Email',
  CODE: 'Code',
  CITY: 'City',
  COMMENTS: 'Comments (Optional)',
  BRANCH: 'Branch',
  PASSWORD: 'Password',
  NAME: 'Name',
  SURNAME: 'Surname',
  CARD_HOLDER: 'Card Holder',
  TABLE_NUMBER: 'Table Number',
  RECEIPT_CHECK_NUMBER: 'Check Number',
  MOBILE_NUMBER: 'Enter Your Phone Number',
  SPOT_CODE: '7-Digit Code',
  CARD_HOLDER_NAME: 'Card Holder Name',
  ADDRESS_TYPE: 'Address type',
  AGREED_CONDITION: 'I agree with the terms and conditions.',
  USE_DIFFERENT_NUMBER: 'Use a different number',
  REQUEST_DETAILS: 'Comment',
  REQUEST_DATA: 'Request data',
  DELETE_DATA: 'Delete data',
  PROVIDE_FEEDBACK: 'PROVIDE FEEDBACK',
  MYDATA_SUBMIT: 'Submit',
  SURVEY_FEEDBACK: 'Add your comment',
  ENTER_AMOUNT: 'Enter an amount',

  // Other_tips Placeholders
  ENTER_PERCENTAGE: 'Enter percentage %',
  ENTER_TIP_AMOUNT: 'Enter tip amount',

  // Navigations Tab labels
  HOME: 'Check In',
  OFFERS_PROMOTIONS: 'Offers & Promotions',
  WALLET: 'Payments',
  WALLET_DELETE: 'Delete Card',
  LOYALTY_ACCOUNTS: 'Loyalty Accounts',
  SIGN_OUT: 'Sign Out',
  PASSWORD_RESET: 'Password reset',
  PROFILE: 'Profile',
  PREFERENCES: 'Email / SMS Preferences',
  LOGOUT: 'Log Out',
  ACCOUNT: 'My Account',
  SUBSCRIPTION: 'Subscription',

  // Others
  YOUR_CHECK_TOTAL: 'Your Check Total',
  SUB_TOTAL: 'Subtotal',
  SUB_TOTAL2: 'Sub Total',
  TAX: 'Tax',
  TIP: 'Tip',
  TAX2: 'Tax',
  TIP2: 'Tip',
  // select item page
  SELECT_ALL: 'Select All',
  CONTINUE_WITH_SELECTION: 'Continue with selection',
  SELECT_ALL_ITEMS_AND_CONTINUE: 'Select all items and continue',
  PAY_SELECTED: 'Pay Selected',
  PAY_ALL: 'Pay all',

  // TOTAL_AMOUNT: 'Total Amount',
  TOTAL: 'Total',
  INCLUDING_TIP_NEW_TOTAL: 'Including tip, pay a total of',
  TIPS: 'Tips',
  DISCOUNTS: 'Discounts',
  LOCATION: 'Location',
  ACTIONS: 'Actions',
  EXPIRES_ON: 'Expires on',
  READ_ONLY: '(read only)',
  EACH: ' each',
  YOUR_CHECK_SPLIT: 'Your check has been splited among ',
  MEMBERS: 'members with ',
  YOUR_ITEMS_CHECK_LIST: 'Your items check list',
  SERVICE_CHARGE: 'Service Charge',
  ADDITIONAL_CHARGE: 'Additional Charge',
  DISCOUNT_AMOUNT: 'Discount',
  TIP_AMOUNT: 'Tip',
  DUE: 'Due',
  PERCENT: 'Percent',
  AMOUNT: 'Amount',
  TOTALS: 'TOTAL',
  CHECK_TOTAL: 'Check total',
  STORE_SELECTION: 'Store Selection',
  SENSOR_ASSIGNMENT: 'Sensor Assignment',
  MANAGE: 'Manage',
  SENSOR: 'Sensor',
  TOO_FAST: 'Too Fast',
  TOO_SLOW: 'Too Slow',
  JUST_RIGHT: 'Just Right',
  CONFIRM: 'Delete',
  CARD_CONFIRM: 'Confirm',
  TOTAL_DUE: 'Total due',
  TOTAL_DUE2: 'Total Due',
  PAYMENT_TOTAL: 'Total',
  PAYMENTS: 'Payments',
  TOTAL_AMOUNT: 'TOTAL',


  // Spit Check
  PAY: 'Pay',
  PAY_REMAINING_BALANCE: 'Pay Remaining Balance',


  // Ordering
  ORDER: 'Order',
  REORDER: 'Reorder',
  VIEW: 'View',
  MODIFY: 'MODIFY',
  ORDER_ANOTHER: 'ORDER ANOTHER',
  ADD_TO_CART: 'Add to Bag',
  ADD: 'Add',
  UPDATE_CART: 'Update Bag',
  APPLY: 'Apply',
  SKIP_NAME: 'Skip',
  ADD_TO_CARTS: 'Add to Cart',

  // Payment screen
  OFFERS: 'Offers',
  GIFT_CARD: 'Gift card',
  ADD_GIFT_CARD: 'Add a gift card',
  EDIT_GIFT_CARD: 'Edit a gift card',
  ROUND_UP: 'Round up',
  DELIVERY_FEE: 'Delivery Fee',
  DELIVERY: 'Delivery',
  PICKUP: 'Pickup',
  REFRESH: 'Refresh',
  RETRY_PAYMENT: 'Retry Payment',
  SUBMIT_ORDER: 'Submit Order',
  COUPON: 'Coupon',
  LOYALTY_AND_OFFERS: 'Offers',
  EDIT_LOYALTY_AND_OFFERS: 'Edit Loyalty & Offers',
  TAX_RESTAURANT_CHARGES: 'Tax & Restaurant Charges',
  ITEM_TOTAL: 'Item total',
  PAYMENT_OPTIONS: 'Payment Options',

  // Check Number screen
  CHECK_NUMBER: 'Check Number',
  FULL_CHECK: 'Full Check',
  SPLIT_EVENLY: 'Split Evenly',
  SPLIT_ITEMS: 'Select Items',
  PAY_AN_AMOUNT: 'Pay An Amount',
  PAY_MY_ITEMS: 'Pay My Items',
  PAY_BY_GUEST: 'Pay By Guest',

  DINE_IN: 'Dine In',
  TAKE_OUT: 'Take Out',
  ORDER_NOW: 'Order Now',
  DC_NAME_OF_THIS_ORDER: 'Enter a name for this order',

  // Footer Screens
  FOOTER_HOME: 'Home',
  FOOTER_MENUS: 'Menus',
  FOOTER_ORDERS: 'Order',
  FOOTER_MY_BAG: 'My Bag',
  FOOTER_MORE: 'More',
  FAVOURITE: 'Favorite',
  BROWSE: 'Browse',
  FOOTER_STORE: 'Restaurants',
  FOOTER_MY_CHECK: 'My Check',


  // HOME SCREEN, REFILL, DAISY CHAIN
  CLICKTOPAYLABEL: 'CLICK TO PAY',
  ADD_ITEMS_TO_REFILL: 'Add items to refill',
  ADD_TO_BAG: 'Add to Bag',
  REFILL_REMOVE: 'Remove',
  REFILL: 'Refill',
  REFILL_EMPTY_CART_MSG: 'Sorry, your order does not contain any items that are eligible for a refill',

  // DAISY CHAIN BUTTONS
  DAISY_FIRST_PERSON_YES: 'Yes, I’m the only one',
  DAISY_FIRST_PERSON_NO: 'No, I’m not the only one',
  DAISY_LAST_PERSON_YES: 'Yes, I’m the last one',
  DAISY_LAST_PERSON_NO: 'No, I’m not the last one',


  // Walkup Screen
  WHAT_WOULD_YOU_LIKE: 'What would you like to today',
  NO_OF_GUEST: 'Number of Guest In Your Party',
  HOW_MANY_CHILDREN: 'Of your guest,How Many are Children?',
  CHECK_AVAILABILITY: 'Check Availability',
  ADD_TO_WAIT_LIST: 'Add to Wait List',

  // Spot Screens
  ENTER_NAME_BELOW: 'Enter your name below',

  // Up sell
  MAY_WE_SUGGEST: 'May we suggest?',

  // Multicart
  CHECKOUT: 'Check out',
  PLACE_MY_ORDER: 'Place My Order',

  // Pay Later
  PAY_LATER: 'Pay Later',

  // Other tips messages
  TIP_THIS_AMOUNT: 'Tip this amount:',

  // Tips Home
  CARD_CHARGED: 'If you proceed, your card will be charged.',
  PROCEED_ORDER_PLACED: 'If you continue, your order will be placed.',

  DC_ORDER_MSG: 'Are you the last person to add to this order?',
  DC_ORDER_PLACE_MSG: 'Are you the only person sending an order right now?',
  HAS_PLACED_ORDER: 'has placed an order.',
  HAVE_PLACED_ORDER: 'have placed their orders.',

  HOW_MANY_PPL: 'Select how many people will split this check',

  RECEIPT_OPTION: 'Choose a receipt option',

  OUT_OF_STOCK: 'Out of Stock',

  ADD_CARD: 'Add Card',
  WALLET_ADD_NEW_CARD: 'Add new card',

  REMOVE_CARD: 'Remove Card',
  SAVE_CARD: 'save card',
  PER_PERSON: 'The amount per person',
  SPLIT: 'Confirm Split',

  // Coupon Labels
  REMOVE_COUPON: 'Remove Coupon',
  APPLY_COUPON: 'Apply',
  APPLY_COUPON_OFFER: 'Apply Offer',
  SKIP_COUPON_OFFER: 'Skip Offer',
  COUPON_CODE: 'Coupon Code',

  // LOYALTY
  LOYALTY_ALREADY_MEMBER: 'Already a member',
  LOYALTY_JOIN_NOW: 'Join now',
  LOYALTY_ACCOUNT_NUMBER: 'Account :',

  LOYALTY_ACC_NUMBER: 'Account Number',
  LOYALTY_PHONE_NUMBER: 'Phone Number',
  LOYALTY_EMAIL_ADDRESS: 'Email Address',
  LOYALTY_QR_CODE: 'QR code',
  LOYALTY_DISPLAY_ACC_NUMBER: 'Account',
  LOYALTY_DISPLAY_OFFER: 'Offer',
  LOYALTY_OFFER_AMOUNT: 'Amount',

  LOYALTY_SELECT_AN_OFFER: 'Offers available',
  NO_OFFERS_AVALIABLE: 'No offers currently available',
  LOYALTY_SKIP_OFFER: 'Skip Offer',
  LOYALTY_APPLY_OFFER: 'Apply Offer',
  LOYALTY_LOGIN: 'Login or Register for Rewards',
  LOOKUP_SUBMIT: 'Submit',
  LOYALTY_VALID_FROM: 'Valid from: ',
  LOYALTY_EXPIRES_ON: 'Expires on: ',
  LOYALTY_VALUE: 'Value',
  PAYMENT_VIEW_OFFER: 'View Loyalty Offers ',

  // Loyalty Wallet
  VALUE: 'Value:',
  START_DATE: 'Start date ',
  END_DATE: 'End date ',
  LOYALTY_AVAILABLE_OFFER: 'Available Offers',

  // Pre auth
  HOLD: 'Hold Amount',
  AUTHORIZE_CARD: 'Authorize card',
  I_AGREE: 'I Agree',
  KEEP_IT_OPEN: 'Keep it open',

  // Menu Item Badge
  VIEW_ONLY: 'View Only',
  NEW_ITEM: 'New Item',
  LIMITED_TIME: 'Limited Time',
  FEATURED: 'Featured',
  SPECIAL: 'Special',

  CART: 'Cart',
  MY_ORDER: 'My Order',
  // Currency symbol
  CURRENCY_SYMBOL: '$',
  PERCENTAGE_SYMBOL: '%',
  YOUR_CART: 'Your Cart',

  // Date Format
  DATE_FORMAT_LONG: 'MM/DD/YYYY',
  DATE_FORMAT_SHORT: 'MM/DD/YY',
  DATE_FORMAT: 'YYYY-MM-DD',
  DATE_FORMAT_UK_LONG: 'DD/MM/YYYY',

  LOYALTY_WALLET_NAME: 'Name',
  LOYALTY_UPDATE_NAME: 'Update Card Name',

  APARTMENT_NUMBER: 'Apartment or suite number (optional)',

  // Table Grouping Order
  JOIN_CHECK_AND_CONTINUE: 'Join check and continue',
  START_A_NEW_CHECK: 'Start a new check',
  JOIN_EXISTING_CHECK: 'Join existing check',
  JOIN_PARTY_WITH: 'Join a party with',
  PAYING_FOR_MYSELF: 'Paying for myself',
  PAYING_FOR_MYSELF_AND_OTHERS: 'Paying for myself + My party',
  SOMEONE_ELSE_IS_PAYING: 'Someone else is paying my tab',

  // Address Management
  WALLET_ADDRESS: 'Address Book',
  WALLET_ADDRESS_NAME: 'Enter Name',
  WALLET_LOOK_UP_ADDRESS: 'Lookup Address',
  WALLET_ADDRESS_UPDATE: 'Update',
  WALLET_ADDRESS_SAVE: 'Save',
  WALLET_ADD_ADDRESS: 'Add Address',
  WALLET_Edit_ADDRESS: 'Edit Address',
  WALLET_DELETE_ADDRESS: 'Delete Address',
  WALLET_SEARCH_ADDRESS: 'Search Address',
  WALLET_SEARCH_ADDRESS_EDIT: 'Address',
  WALLET_EDIT_NAME: 'Name',

  CART_BUTTON: 'SUBMIT ORDER',

  SEND_NOW: 'Send now',
  IMMEDIATE_ADD_TO_BAG: 'Add to Bag',
  CHECKOUT_DELIVER_TO: 'Deliver TO',
  CHECKOUT_SPOT_NUMBER: 'Spot Number',

  DATE: 'Date',
  PAY_WITH_STRIPE: 'PAY WITH CREDIT CARD',
  PAY_WITH_SPREEDLY: 'Pay with Spreedly',
  SPECIAL_INSTRUCTIONS: 'Add Special Instructions',
  ADD_A_NOTE: 'Add a note',
  ITEM_SEARCH: 'Search',
  PICK_UP_TO: 'Pick up to',
  OPTIONAL: 'optional',
  SELECT_UPTO: 'Select upto',

  SELECT_DELIVERY_TIME: 'Select Delivery Time',
  SELECT_PICK_UP_TIME: 'Select Pickup Time',
  SELECT_PICK_UP_DATE: 'Select Pickup Date',
  EDIT_ONL_ORDERS_YES: 'Yes',
  EDIT_ONL_ORDERS_NO: 'No',
  EDIT_ONL_ORDERS_OK: 'Ok',
  EDIT_CU_ORDERS_NAME: 'Name',
  DESKTOP_LOGIN: 'Login',
  DELIVERY_ADDRESS: 'Delivery Address',
  TIME: 'Time',
  SKIP_SURVEY: 'Skip Survey',
  SURVEY_NEXT: 'Next',
  SURVEY_DONE: 'Done',
  SURVEY_CONTINUE: 'Take the survey',
  COMING_SOON: 'Coming soon',
  LIMITED_QUANTITY: 'Limited quantity',
  ADDITIONAL_TIME: 'Addtional Time',
  TIME_RESTRICTED: 'Time Restricted',
  DRIVE_THRU: 'Drive thru',
  TIP_ROUNDUP: 'Use tip to round up total',
  ADDITIONAL_TIP: 'Additional Tip',
  CLICK_TO_CALL: 'Call Restaurant',

  CHANGE_LOCATION: 'Change Location',
  CURRENT_LOCATION: 'Current Location',
  CONFIRM_LOCATION: 'Confirm Location',

  VENUE_RECIEPT: 'Receipt',
  RECIEPT: 'Receipt',


  // Payment
  ADD_CREDIT_CARD: 'Add credit card',
  HOLD_WITH: 'Hold with',
  CLICK_TO_PAY: 'CLICK TO PAY',

  // LOCATION HEADER
  HEADER_LOCATION: 'Location',
  HEADER_TABLE: 'Table',
  HEADER_CHECK: 'Check #',

  // Card Wallets
  USE_SAVED_CARD: 'Use a saved card',
  MY_SAVED_CARD: 'My saved card',
  CARD_NAME: 'Card Name',
  EXP: 'Exp',
  ENTER_NEW_CARD: 'Enter new card',
  CHANGE_CARD: 'Change card',
  UPDATE_CARD_NAME: 'Update Card Name',
  ACC_WALLET_SAVE: 'Save',
  ACC_WALLET_CANCEL: 'No',
  ACC_WALLET_SAVE_CHANGES: 'Save Changes',
  TEMPORARY_HOLD: '(temporary hold)',
  ACC_WALLET_CONFIRM: 'Yes',
  WALLET_TITLE: 'CARDS AND MEAL PASS',

  // Add Card
  ENTER_CREDIT_CARD: 'Enter Credit Card',
  CARD_NUMBER: 'Card number',
  EXPIRY_DATE: 'Expiry Date',
  CVV: 'Cvv',
  ZIP_CODE: 'Zip code',
  FULL_NAME_CARD: 'Full name on card',
  EXP_DATE: 'Exp date',
  POST_CVV: 'CVV',

  // Payment card keys
  CARD_FIRST_NAME: 'First Name',
  CARD_LAST_NAME: 'Last Name',
  CARD_CREDIT_NUMBER: 'Credit Card Number',
  CARD_CVV: 'CVV',
  CARD_EXP_DATE: 'Expiration Date',
  CARD_ZIPCODE: 'Zip code',
  CARD_ADDRESS1: 'Address1',
  CARD_ADDRESS2: 'Address2',
  CARD_CITY: 'City',
  CARD_STATE: 'State',

  CONTINUE_BTN: 'Continue',
  ENTER_MOBILE_NUMBER_LOGIN: 'Enter Mobile Number',
  USE_EMAIL_ADRESS: 'Use an email address',

  SEARCH_ADDRESS: 'Search address',

  // Survey
  SUR_PREVIOUS: 'Previous',
  SUR_Back: 'Back',
  SUR_NEXT: 'Next',
  SUR_SUBMIT: 'Submit',

  // Past Order History
  PAST_ORDER_TOTAL: 'Total',
  PAST_ORDER_SUBTOTAL: 'Subtotal:',
  PAST_ORDER_TIP: 'Tip',
  PAST_ORDER_TAX: 'Tax',

  // USAEPAY,
  USA_CREDIT_CARD_LABEL: 'Enter Credit/Debit Card',
  USA_FULL_NAME: 'Full name on card',
  USA_ZIPCODE: 'Zip code',

  // HEARTLAND,
  HL_CARD_NUMBER_LABEL: 'Enter card number',
  HL_CARD_EXPIRY_LABLE: 'Enter expiry date',
  HL_CARD_CVV_LABLE: 'Enter cvv',
  HL_CARD_FULL_NAME: 'Full name on card',
  HL_ZIP_CODE: 'Enter Zip code',
  HL_CARD_NUMBER_PLACEHOLDER: '•••• •••• •••• ••••',
  HL_CARD_EXPIRY_PLACEHOLDER: 'MM / YYYY',
  HL_CARD_CVV_PLACEHOLDER: 'cvv',
  HL_ZIP_PLACEHOLDER: 'zip code',
  HL_CARD_SUBMIT_BTN: 'Add Card',

  // GLOBAL PAYMENT
  GP_ZIPCODE: 'Enter Postal Code',
  GP_ZIPCODE_PLACEHOLDER: 'Postal Code',

  // stripe
  STRIPE_FULL_NAME_ON_CARD: 'Full name on card',

  // GIFT CARD
  GC_BALANCE: 'Check balance',
  GC_BALANCE_AMT: 'Balance Amount: ',
  GC_REDEEM_AMT: 'Redeemed Amount: ',
  GC_TOTAL_DUE: 'Total Due: ',
  GC_AMT_APPLY: 'Amount to apply: ',
  GC_REDEEM: 'Redeem',
  SKIP_GIFTCARD: ' Skip Gift Card',
  APPLY_GIFTCARD: ' Apply Gift Card',
  GC_CARD_NUMBER: 'Gift Card Number:',

  // OFFER SCREEN
  VIEW_OFFER: 'View Offers',
  VIEW_REWARDS_AND_OFFERS: 'View Rewards & Offers',
  REMOVE_OFFER: 'Remove Offer',

  YOUR_DATA: 'Your Data',

  RECEIPT_TABLE_NUMBER: 'Table Number',
  RECEIPT_DELIVER_TO: 'Deliver to',
  RECEIPT_TXN_ID: 'Transaction Id',
  RECEIPT_PAYPAL_EMAIL: 'PayPal Email',

  MODIFIER_REMOVE: 'Remove',
  MODIFIER_DONE: 'Done',

  INVALID_SENSOR_CLICK_TO_SCAN: 'CLICK TO SCAN',
  INVALID_SENSOR_CLICK_TO_SCANQRIO: 'CLICK TO SCAN WITH SCANQR.IO',

  // Charity
  CHARITY: 'Charity',
  CHARITY_EDIT: 'Edit charity',
  CHARITY_AMOUNT: 'Amount',
  CHARITY_TO_DONATE: 'Charity to donate',
  CHARITY_DONATE: 'Donate',
  CHARITY_OTHER: 'Other',
  CHARITY_ROUNDUP: 'Round it up',

  SCAN_HOST_QR_CODE: 'Scan host\'s Invite QR',

  PAY_MY_CHECK: 'Pay My Check',

  PAY_ONLY_MODE_RETRY: 'Retry',

  BUDGET: 'Remaining Budget',

  CLICK_TO_CONTINUE: 'Click next to continue',

  LOYALTY_SIGN_IN: 'Loyalty Sign In',
  LOYALTY_SIGN_UP: 'Loyalty Sign Up',
  LOYALTY_OPT_IN: 'Loyalty Opt In',
  LOYALTY_FORGOT_PASSWORD: 'Loyalty Forgot Password',
  LOYALTY_CONFIRM_PASSWORD: 'Confirm Password',
  OPT_IN_TEXT: 'Opt In',
  USE_MY_LOCATION: 'Use My Location',
  TIER_LABEL_TEXT: 'Tier',
  POINTS_LABEL_TEXT: 'Points',
  ESTIMATED_POINTS_EARNED: 'Estimated points earned',
  PRIVACY_POLICY: 'Privacy Policy',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  COOKIES: 'Cookies',
  COMPLETE_PAYMENT: 'Complete Payment',
  TABLE_RETRY: 'Retry',
  ADD_FOR: 'Add for',
  CALL_SERVER: 'CALL SERVER',
  NOTIFY_SERVER: 'Notify Server',
  AGE_RESTRICTED_EDIT_CART: 'Edit Cart',
  AGE_RESTRICTED_CONTINUE: 'Continue',
  PAY_BY_STAGE: 'Pay by stage',
  STAGE: 'Split',
  FOOTER_CALL_SERVER: 'Call Server',
  MYDATA_CANCEL: 'Cancel',
  MYDATA_OK: 'Ok',

  // Wait-list
  WAIT_LIST_NAME: 'Name',
  WAIT_LIST_PARTY_SIZE: 'Party Size',
  WAIT_LIST_COUNTRY_CODE: 'Country Code',
  WAIT_LIST_EMAIL_ADDRESS: 'Email Address (Optional)',
  WAIT_LIST_NOTE: 'Note (Optional)',
  WAIT_LIST_SUBMIT: 'Submit',
  WAIT_LIST_CANCEL: 'Cancel',
  WAIT_LIST_MODIFY: 'Modify',
  WAIT_LIST_YES: 'Yes',
  WAIT_LIST_NO: 'No',
  WAIT_LIST_WAIT_PHONE_NUMBER: 'Phone',
  WAIT_LIST_UPDATE: 'Update',
  WAIT_LIST_EMAIL_INFO: 'Email',
  WAIT_LIST_NOTE_INFO: 'Note',

  // Cabbage-Pay
  CABBAGE_PAY_BTN: 'Pay with Cabbage',
  CABBAGE_SWITCH_BANK: 'Switch bank account',

  // DOJO Payment
  DOJO_PAY_WITH_CREDIT_CARD: 'Pay with Credit Card',
  DOJO_SAVE_CARD: 'Save Card',
  DOJO_PAY_WITH_APPLE_PAY: 'Pay with Apple Pay',
  DOJO_PAY_WITH_GOOGLE_PAY: 'Pay with Google Pay',

  // Pre Order
  PRE_SKIP: 'Skip',
  PRE_ORDER: 'Order',
  PRE_ORDER_ORDER_ONE_DRINK: 'Order One Drink',
  PRE_ORDER_ORDER_MORE_THAN_ONE_DRINK: 'Order More Than One Round',
  PRE_EVERY: 'Every',
  PRE_MINUTES: 'minutes',
  PRE_TIMES: 'times',

  DELIVERY_APARTMENT_NUMBER: 'Apartment / Suite (optional)',
  DELIVERY_ORDER_NOTE: 'Order note (optional)',

  SURVEY_CONTACT_FORM_YES: 'Yes',
  SURVEY_CONTACT_FORM_NO: 'No',

  // CARDCONNECT
  CARD_CONNECT_EXPIRY: 'Enter Card Expiry Date',
  CARD_CONNECT_CVV: 'Enter Card CVV',

  ADD_UTENSILS: 'Add Utensils?',

  OPT_IN_RECIEVE_EMAIL: 'Opt in to receive emails',
  OPT_IN_RECIEVE_SMS: 'Opt in to receive SMS',

  SKIP_CHECK_IN: 'Skip check in',
  CHECK_NUMBER_NEXT: 'Check In',
  SKIP_OPT_IN: 'Skip Opt In',

  PICKUP_VEHICLE_DESCRIPTION_TEXT: 'Vehicle Description',
  ORDERDETAIL_NAME: 'Enter your name',
  PICKUP_NOTES: 'Add order notes (Optional)',


  // Order-details
  ENTER_YOUR_NAME: 'Enter your name',
  ADD_ORDER_NOTES: 'Add order notes (Optional)',
  ORDER_CONFIRM: 'Confirm',

  ADD_ITEMS: 'Add more items',
  CUTLERY: 'Send cutlery',
  YOUR_ITEMS: 'Your items',
  ORDER_NOTES: 'Order Notes',
  APARTMENT_SUITE: 'Apartment Suite',
  SHOW_LESS: 'Show less',

  // receipt info
  ORDER_CONFIRMED: 'Your order is confirmed',
  ACCEPT_ORDER: 'We have accepted your order, and we are getting it ready. Please check this page for more updates about your order.',
  VIEW_DIRECTIONS: 'View directions',
  CONTACT_RESTAURANT: 'Contact restaurant',
  PICK_UP_TIME: 'Pickup time',
  PICK_UP_DATE: 'Pickup Date',
  DELIVERY_DATE: 'Delivery Date',
  DELIVERY_TIME: 'Delivery time',
  RECEIPT_SUBTOTAL: 'Subtotal',

  // LANDING SCREEN - PICK UP AND DELIVERY//
  OLS_PICK_UP: 'Pick up',
  OLS_DATE_TIME_INPUT_LABEL: 'Date & Time',
  OLS_PICKUP_VEHICLE_DESCRIPTION: 'Vehicle Description (Optional)',
  OLS_SELECT_PICK_UP_DATE: 'Select Pickup Date',
  OLS_SELECT_PICK_UP_TIME: 'Select Pickup Time',
  OLS_NEXT: 'Next',
  OLS_SCHEDULE: 'Schedule',
  OLS_APPLY: 'Apply',
  OLS_CANCEL: 'Cancel',
  OLS_DELIVERY: 'Delivery',
  OLS_DELIVERY_ADDRESS: 'Delivery Address',
  OLS_APARTMENT_SUITE_INPUT_LABEL: 'Apartment suite (Optional)',
  OLS_SELECT_DELIVERY_DATE: 'Select Delivery Date',
  OLS_SELECT_DELIVERY_TIME: 'Select Delivery Time',
  OLS_DELIVERY_ADDRESS_DONE: 'Done',
  OLS_PLEASE_SELECT_AN_ADDRESS: 'Please select an address',

  // Walkup - Landing Screen
  WLS_DINE_IN: 'Dine In',
  WLS_TAKE_OUT: 'Takeout',
  WLS_NAME: 'Name',
  WLS_NEXT: 'Next',

  // Curbside - Landing Screen
  CLS_SPOT_NUMBER: 'Spot Number',
  CLS_NEXT: 'Next',
  CLS_VEHICLE_TYPE: 'Vehicle Type',
  CLS_VEHICLE_COLOR: 'Vehicle Color',
  CLS_CHANGE: 'Change',
  CLS_CONFIRM: 'Confirm',
  CLS_CANCEL: 'Cancel',

  // Account - Payment screen
  APM_PAYMENT_METHODS: 'Manage payment methods',
  APM_UPDATE_NAME: 'Update Card Name',
  APM_ENTER_CARD_NAME: 'Enter Card Name',
  APM_SAVE: 'Save',
  APM_CANCEL: 'Cancel',
  APM_NO: 'No',
  APM_DELETE_CARD: 'Delete Card',
  APM_YES: 'Yes',
  APM_EXPIRES_ON: 'Expires on',
  APM_DONE: 'Done',

  // Account - My Data
  AMD_YOUR_DATA: 'Your Data',
  AMD_ENTER_MOBILE_NUMBER: 'Enter Mobile Number',
  AMD_EMAIL_ADDRESS: 'Email Address',
  AMD_FIRST_NAME: 'First Name',
  AMD_LAST_NAME: 'Last Name',
  AMD_REQUEST_DATA: 'Request data',
  AMD_DELETE_DATA: 'Delete data',
  AMD_COMMENT: 'Comment',
  AMD_SUBMIT: 'Submit',
  AMD_CONFIRMATION: 'Confirmation',
  AMD_YES: 'Yes',
  AMD_CANCEL: 'Cancel',

  // Account - OptIn Screen
  AOI_OPT_IN: 'Opt In',
  AOI_RECIVE_COMMUNICATION: 'Opt in to receive communication',
  AOI_PHONE_NUMBER: 'Phone Number',
  AOI_EMAIL_ADDRESS: 'Email Address',
  AOI_SAVE: 'Save',

  // Account - Profile Settings
  APS_PROFILE_SETTINGS: 'Profile Settings',
  APS_USER_NAME: 'User Name',
  APS_FIRST_NAME: 'First Name',
  APS_LAST_NAME: 'Last Name',
  APS_ORDER_NICKNAME: 'Order Nickname',
  APS_PHONE_NUMBER: 'Phone Number',
  APS_EMAIL_ADDRESS: 'Email Address',
  APS_SAVE_CHANGES: 'Save Changes',
  APS_PASSWORD_RESET: 'Password reset',
  APS_CHANGE_PASSWORD: 'Change Your Password',
  APS_CURRENT_PASSWORD: 'Current Password',
  APS_NEW_PASSWORD: 'New Password',
  APS_CONFIRM_PASSWORD: 'Confirm Password',
  // My Account Screen

  AMA_MY_ACCOUNT: 'My Account',
  AMA_PROFILE: 'Profile',
  AMA_PAYMENTS: 'Payments',
  AMA_LOYALTY_ACCOUNTS: 'Loyalty Accounts',
  AMA_OPT_IN: 'Opt In',
  AMA_ADDRESS_BOOK: 'Address Book',
  AMA_PAST_ORDERS: 'Past Orders',
  AMA_SIGN_OUT: 'Sign Out',
  AMA_PRIVACY_POLICY: 'Privacy Policy',
  AMA_TERMS_AND_CONDITION: 'Terms and Conditions',
  AMA_COOKIES: 'Cookies',
  AMA_MY_DATA: 'My Data',
  AMA_VERSION: 'Version',

  // Account - Loyalty Screen

  ALA_LOYALTY_ACCOUNTS: 'Loyalty Accounts',
  ALA_UPDATE_NAME: 'Update Card Name',
  ALA_ENTER_CARD_NAME: 'Enter Card Name',
  ALA_SAVE: 'Save',
  ALA_CANCEL: 'Cancel',
  ALA_DELETE_CARD: 'Delete Card',
  ALA_YES: 'Yes',
  ALA_NO: 'No',
  ALA_CONFIRM: 'Confirm',
  ALA_OFFERS_AVAILABLE: 'Offers available',
  ALA_ACCOUNT_NUMBER: 'Account :',
  ALA_POINTS: 'Points',
  ALA_VALID_FROM: 'Valid from: ',
  ALA_EXPIRES_ON: 'Expires on: ',
  ALA_VIEW_OFFERS: 'View Offers',

  // Account - Pastorders
  APO_PAST_ORDERS: 'Past Orders',
  APO_VIEW_DETAILS: 'View Details',
  APO_ITEM_TOTAL: 'Item Total',
  APO_DELIVERY_FEE: 'Delivery fee',
  APO_TIP: 'Tip',
  APO_TAX_RESTAURANT_CHARGES: 'Tax & Restaurant Charges',
  APO_TOTAL: 'Total',

  // ORDERS SCREEN LABELS
  ORS_SEARCH: 'Search',
  ORS_VIEW: 'View',
  ORS_ORDER: 'Order',
  ORS_MORE: 'more',
  ORS_CAL: 'CAL',
  ORS_NO: 'No',
  ORS_YES: 'Yes',
  ORS_TOTAL_DUE: 'Total Due',
  ORS_CLICK_TO_PAY: 'CLICK TO PAY',

  // Checkout Screen LABELS
  OCS_YOUR_CART: 'Your Cart',
  OCS_ITEMS: 'ITEMS',
  OCS_EDIT: 'Edit',
  OCS_SUBTOTAL: 'Subtotal',
  OCS_CHECKOUT: 'Check out',
  OCS_YES: 'Yes',
  OCS_NO: 'No',
  OCS_TOTALDUE: 'Total Due',
  // Account - Address Book
  AAB_ADDRESS_BOOK: 'Address Book',
  AAB_ADD_ADDRESS: 'Add Address',
  AAB_SEARCH_ADRESS: 'Search Address',
  AAB_ENTER_NAME: 'Enter Name',
  AAB_CANCEL: 'Cancel',
  AAB_SAVE: 'Save',
  AAB_EDIT_ADDRESS: 'Edit Address',
  AAB_ADDRESS: 'Address',
  AAB_NAME: 'Name',
  AAB_DELETE_ADDRESS: 'Delete Address',
  AAB_DELETE: 'Delete',
  AAB_ADDRESS_UPDATE: 'Update',
  AAB_NO: 'No',
  AAB_YES: 'Yes',

  // Upsell Screen LABELS
  USS_ORDER: 'Order',
  USS_SKIP: 'Skip',
  USS_CONTINUE: 'Continue',
  USS_YES: 'Yes',
  USS_NO: 'No',


  // ITEMDETAILS SCREEN LABELS
  IDS_CAL: 'Cal',
  IDS_SHOW_MORE: 'Show more',
  IDS_SHOW_LESS: 'Show less',
  IDS_NUTRITION_FACT: 'Nutrition Facts',
  IDS_TOTAL: 'Total',
  IDS_YES: 'Yes',
  IDS_NO: 'No',
  IDS_UPDATE_CART: 'Update Bag',
  IDS_ADD_TO_CART: 'Add to Bag',
  IDS_SERVING_SIZE: 'Servings size',
  IDS_CALORIES: 'Calories',
  IDS_TOTAL_FAT: 'Total Fat',
  IDS_SATURATED_FAT: 'Saturated Fat',
  IDS_TRANS_FAT: 'Trans Fat',
  IDS_CHOLESTROL: 'Cholesterol',
  IDS_SODIUM: 'Sodium',
  IDS_TOTAL_CARBOHYDRATE: 'Total Carbohydrate',
  IDS_DIETARY_FIBER: 'Dietary Fiber',
  IDS_TOTAL_SUGARS: 'Total Sugars',
  IDS_INCLUDES: 'Includes',
  IDS_ADDED_SUGARS: 'Added Sugars',
  IDS_PROTEIN: 'Protein',
  IDS_VITAMIND: 'Vitamin D',
  IDS_CALCIUM: 'Calcium',
  IDS_IRON: 'Iron',
  IDS_POTASSIUM: 'Potassium',
  IDS_SELECT_ANY: 'Select any (optional)',
  IDS_REMOVE: 'Remove',
  IDS_DONE: 'Done',
  IDS_SKIP: 'Skip',
  IDS_APPLY: 'Apply',
  IDS_OK: 'OK',
  IDS_SPECIAL_INSTRUCTIONS: 'Add Special Instructions ({{remaining}} of {{total}} remaining)',
  IDS_SELECT_REQUIRED: 'Select {{minValue}} to {{maxValue}} items (required)',
  IDS_SELECT_UPTO: 'Select upto {{maxValue}} (optional)',

  // Order detail Screen
  ODS_ORDER_DETAILS: 'Order Details',
  ODS_ENTER_ORDER_DETAILS: 'Enter your Order details',
  ODS_SPOT_NUMBER: 'Spot Number',
  ODS_NAME: 'Enter Your Name',
  ODS_ADD_ORDER_NOTES: 'Add order notes (Optional)',
  ODS_PICK_UP: 'Pick up',
  ODS_DELIVERY: 'Delivery',
  ODS_DATE_TIME: 'Date & Time',
  ODS_VEHICLE_DESCRIPTION: 'Vehicle Description',
  ODS_ADD_UTENSILS: 'Add Utensils?',
  ODS_DELIVERY_ADDRESS: 'Delivery Address',
  ODS_APARTMENT_SUITE: 'Apartment Suite (Optional)',
  ODS_CONFIRM: 'Confirm',
  ODS_SELECT_DELIVERY_DATE: 'Select Delivery Date',
  ODS_SELECT_DELIVERY_TIME: 'Select Delivery Time',
  ODS_SELECT_PICKUP_DATE: 'Select Pickup Date',
  ODS_SELECT_PICKUP_TIME: 'Select Pickup Time',
  ODS_APPLY: 'Apply',
  ODS_CANCEL: 'Cancel',
  ODS_CONTINUE_TO_PAYMENT: 'Continue To Payment',
  ODS_SELECT_TYPE: 'Select Vehicle Type',
  ODS_SELECT_COLOR: 'Select Vehicle Color',
  ODS_CURBSIDE_PICKUP: 'Curbside Pickup?',
  ODS_PAY_AT_RESTAURANT: 'Pay At Restaurant',


  // Badges
  BDG_OUT_OF_STOCK: 'Out of Stock',
  BDG_VIEW_ONLY: 'View Only',
  BDG_NEW_ITEM: 'New Item',
  BDG_LIMITED_TIME: 'Limited Time',
  BDG_FEATURED: 'Featured',
  BDG_SPECIAL: 'Special',
  BDG_COMING_SOON: 'Coming Soon',
  BDG_LIMITED_QUANTITY: 'Limited Quantity',
  BDG_ADDITIONAL_TIME: 'Additional Time',
  BDG_TIME_RESTRICTED: 'Time Restricted',

  // Cart Screen
  CS_BAG: 'Bag',
  CS_YOUR_BAG: 'Your Bag',
  CS_YOUR_ITEMS: 'Your items',
  CS_EDIT: 'Edit',
  CS_ADD_MORE_ITEMS: 'Add more items',
  CS_SUB_TOTAL: 'Sub Total:',
  CS_ADD_NAME: 'Add name',
  CS_REVIEW_ORDER: 'Review Order',
  CS_ORDER_NOW: 'Order Now',
  CS_PAY_NOW: 'Pay Now',
  CS_ADD_ITEMS: 'Add Items',

  CS_YES: 'Yes',
  CS_NO: 'No',
  CS_SPOT_NUMBER: 'Spot Number',
  CS_ORDER_NAME: 'Order Name',
  CS_CHANGE: 'Change',
  CS_ORDER_NOTES: 'Order Notes',
  CS_PICKUP_DATE_AND_TIME: 'Pickup Date & Time',
  CS_VEHICLE_DESCRIPTION: 'Vehicle Description',
  CS_DELIVERY_DATE_AND_TIME: 'Delivery Date & Time',
  CS_DELIVERY_ADDRESS: 'Delivery Address',
  CS_APARTMENT_SUITE: 'Apartment Suite',
  CS_ITEMS: 'Items',
  CS_MY_CART: 'My Cart',
  CS_KEEP_IT_OPEN: 'Keep it open',


  // PAYMENT - LOYALTY SCREEN
  LTS_OFFERS: 'Offers',
  LTS_LOYALTY_LOGIN: 'Login or Register for Rewards',
  LTS_VIEW_LOYALTY_OFFER: 'View Loyalty Offers ',
  LTS_LOYALTY_ALREADY_MEMBER: 'Already a member',
  LTS_LOYALTY_JOIN_NOW: 'Join now',
  LTS_LOYALTY_ACC_NUMBER: 'Account Number',
  LTS_LOYALTY_PHONE_NUMBER: 'Phone Number',
  LTS_LOYALTY_EMAIL_ADDRESS: 'Email Address',
  LTS_SIGN_IN: 'Sign In',
  LTS_SIGN_UP: 'Sign up',
  LTS_ENTER_ACC_NUMBER: 'Enter Account Number',
  LTS_ENTER_PHONE_NUMBER: 'Enter Your Phone Number',
  LTS_ENTER_EMAIL_ADDRESS: 'Enter Email Address',
  LTS_LOYALTY_ACCOUNT_NUMBER: 'Account :',
  LTS_LOYALTY_SELECT_AN_OFFER: 'Offers available',
  LTS_NO_OFFERS_AVALIABLE: 'No offers currently available',
  LTS_LOYALTY_SKIP_OFFER: 'Skip Offer',
  LTS_LOYALTY_APPLY_OFFER: 'Apply Offer',
  LTS_YES: 'Yes',
  LTS_NO: 'No',
  LTS_LOYALTY_VALUE: 'Value',
  LTS_POINTS_LABEL_TEXT: 'Points',
  LTS_CONTINUE: 'Continue',

  // Payment - Coupon Screen
  PCS_COUPON: 'Coupon',
  PCS_COUPON_APPLY: 'Apply coupon',
  PCS_ENTER_COUPON_NUMBER: 'Enter coupon number',
  PCS_APPLY_COUPON: 'Apply',
  PCS_CANCEL: 'Cancel',
  PCS_CONFIRM: 'Delete',

  // Payment - Tips Screen
  PTS_ADD_A_TIP: 'Add a tip',
  PTS_NO_TIP: 'No Tip',
  PTS_OTHER: 'Other',
  PTS_ADD_TIP: 'Add Tip',
  PTS_PERCENT: 'Percent',
  PTS_AMOUNT: 'Amount',
  PTS_CANCEL: 'Cancel',
  PTS_ADD_TIP_BTN: 'Add Tip',

  // Payment - full Screen
  PS_PAYMENT: 'Payment',
  MY_CHECK: 'My Check',
  MY_CART: 'My Cart',
  PS_SUB_TOTAL: 'Sub Total',
  PS_TAX: 'Tax',
  PS_TOTAL_DUE: 'Total Due',
  PS_SUBTOTAL_TIP: 'Tip',
  PS_SUBTOTAL_OFFERS: 'Offers',
  PS_SUBTOTAL_GIFTCARD: 'Gift card',
  PS_YOUR_CART: 'Your cart',
  PS_ITEMS: 'Items',
  PS_CHANGE: 'Change',
  PS_CANCEL: 'Cancel',
  PS_CONFIRM: 'Confirm',
  PS_OK: 'OK',
  PS_ORDER_SUMMARY: 'Order Summary',
  PS_OR: 'OR',

  // Payment - Gift Card screen
  PGC_GIFT_CARD: 'Gift card',
  PGC_ADD_GIFT_CARD: 'Add a gift card',
  PGC_BALANCE: 'Check balance',
  PGC_BALANCE_AMT: 'Balance Amount: ',
  PGC_REDEEM_AMT: 'Redeemed Amount: ',
  PGC_SKIP_GIFTCARD: 'Skip Gift Card',
  PGC_YES: 'Yes',
  PGC_NO: 'No',
  PGC_APPLY_GIFTCARD: 'Apply Gift Card',
  PGC_CARD_NUMBER: 'Gift Card Number:',
  PGC_NUMBER: 'Enter gift card number',
  PGC_SECURITY_CODE: 'Enter security code',
  PGC_CHARITY_TO_DONATE: 'Charity',

  // PAMENT - OPTIN SCREEN
  POS_EMAIL_ADDRESS: 'Email Address',
  POS_PHONE_NUMBER: 'Phone Number',
  POS_OPTIN_SAVE: 'Save',
  POS_SKIP_OPT_IN: 'Skip Opt In',

  // Login screen
  LS_VERIFY: 'Verify',
  LS_LOADING: 'Loading',
  LS_CONTINUE_AS_GUEST: 'Continue as Guest',
  LS_VERIFY_YOUR_PHONE: 'Verify Your Phone',
  LS_USERNAME: 'Username',
  LS_ENTER_PASSWORD: 'Password',
  LS_LOGIN: 'Sign In',
  LS_RESET_PASSWORD: 'Reset Password',
  LS_PHONE_NUMBER: 'Phone Number',
  LS_CONFIRM_PASSWORD: 'Confirm Password',
  LS_ENTER_MOBILE_NUMBER: 'Enter Mobile Number',
  LS_SIGN_IN_WITH_YOUR_PHONE_NUMBER: 'Sign in with your phone number',
  LS_SIGN_IN_WITH_PASSWORD: 'Sign in with a password',
  LS_SIGN_IN_TO_YOUR_ACCOUNT: 'Sign in to your account',
  LS_FORGOT_YOUR_PASSWORD: 'Forgot your password?',
  LS_RESET_YOUR_PASSWORD: 'Reset your password',
  LS_REMEMBER_YOUR_PASSWORD: 'Remember your Password?',
  LS_RESET_CODE: 'Code',
  LS_SENDING_OTP: 'Sending',

  // Order Summary Screen
  OSS_VIEW_DIRECTIONS: 'View directions',
  OSS_CONTACT_RESTAURANT: 'Contact restaurant',
  OSS_SPOT_NUMBER: 'Spot Number',
  OSS_VEHICLE_DESCRIPTION: 'Vehicle description',
  OSS_ORDER_SUMMARY: 'Order summary',
  OSS_ITEMS: 'Items',
  OSS_SUB_TOTAL: 'Sub Total',
  OSS_TAX: 'Tax',
  OSS_TIP: 'Tip',
  OSS_TOTAL_DUE: 'TOTAL',
  OSS_VIEW_RECEIPT: 'View Receipt',
  OSS_CHOOSE_RECEIPT_OPTION: 'Choose a receipt option',
  OSS_SMS: 'SMS',
  OSS_EMAIL: 'Email',
  OSS_SHOW_ORDER_SUMMARY: 'Show order summary',
  OSS_HIDE_ORDER_SUMMARY: 'Hide order summary',
  OSS_MOBILE_OPTIN_TITLE: 'Please Enter Your Mobile Number',
  OSS_CLOSE_OPTIN: 'Close',
  OSS_OPTIN_SUBMIT: 'Submit',
  OSS_SMS_OPTIN: 'Please Enter Your Email Address',
  OSS_ESTIMATED_POINTS_EARNED: 'Estimated points earned',

  // Payment Options Screen
  POS_ADD_CREDIT_CARD: 'Add new credit card',
  POS_ADD: 'ADD',
  POS_CLICK_TO_PAY: 'Click To Pay',
  POS_PAYMENT_OPTIONS: 'Payment Options',
  POS_UPDATE_ACCOUNT: 'Update Account',
  OPO_ADD_CREDIT_CARD: 'Add credit card',
  OPO_ADD: 'ADD',
  OPO_CLICK_TO_PAY: 'Click To Pay',
  OPO_PAYMENT_OPTIONS: 'Payment Options',
  OPO_UPDATE_ACCOUNT: 'Update Account',
  // Pre Auth - Payment option
  OPO_HOLD: 'Hold Amount',
  OPO_HOLD_WITH: 'Hold with',
  OPO_I_AGREE: 'I Agree',
  OPO_CONFIRM_CARD: 'Confirm Card',
  OPO_EXPIRES_ON: 'Expires on',

  // Survey Screen LABEL
  SS_SKIP_SURVEY: 'Skip Survey',
  SS_SURVEY_CONTINUE: 'Take the survey',
  SS_BACK: 'Back',
  SS_NEXT: 'Next',
  SS_YES: 'Yes',
  SS_NO: 'No',
  SS_SUBMIT: 'Submit',

  // Receipt Screen
  RS_DELIVER_TO: 'Deliver to',
  RS_QTY: 'Qty',
  RS_ITEM: 'Item(s)',
  RS_AMOUNT: 'Amount',
  RS_SUBTOTAL: 'Sub Total',
  RS_TIP: 'Tip',
  RS_TAX: 'Tax',
  RS_TOTAL: 'Total',
  RS_PAID_WITH_PAYPAL: 'Paid with PayPal',
  RS_TXN_ID: 'Transaction Id',
  RS_PAYPAL_EMAIL: 'PayPal Email',
  RS_PICKUP_DATE: 'Pickup Date',
  RS_PICKUP_TIME: 'Pickup time',
  RS_VEHICLE_DESCRIPTION: 'Vehicle Description',
  RS_DELIVERY_TIME: 'Delivery Time',
  RS_DELIVERY_DATE: 'Delivery Date',
  RS_DELIVERY_ADDRESS: 'Delivery Address',
  RS_APARTMENT_SUITE: 'Apartment Suite',
  RS_DELIVERY_FEE: 'Delivery fee',
  RS_PAYMENT: 'Payment',
  RS_OFFER: 'Offer',
  RS_CHECK_NUMBER: 'Check Number',
  RS_GUEST_NAME: 'Guest Name',
  RS_TABLE_NUMBER: 'Table',
  RS_DISCOUNT: 'Discount',
  RS_SERVICE_CHARGE_AMOUNT: 'Service Charge',
  RS_BEGIN_SURVEY: 'Begin Survey',
  RS_LOADING: 'Loading',
  RS_ROUNDING_UP: 'Rounding Up',
  RS_ROUNDING_DOWN: 'Rounding Down',
  RS_PRINT_RECEIPT: 'Print Receipt',

  // Host Guest Mode
  HGM_PAYING_FOR_MYSELF: 'Paying for myself',
  HGM_PAYING_FOR_MYSELF_AND_OTHERS: 'Paying for myself + My party',
  HGM_SOMEONE_ELSE_IS_PAYING: 'Someone else is paying my tab',
  HGM_CONTINUE: 'Continue',

  // Table Payment Options
  TPO_PAYMENT_OPTIONS: 'Payment Options',
  TPO_SPLIT_EVENLY: 'Split Evenly',
  TPO_PAY_REMAINING_BALANCE: 'Pay Remaining Balance',
  TPO_FULL_CHECK: 'Full Check',
  TPO_PAY: 'Pay',

  // Split - Evenly Screen
  SES_TOTAL_DUE: 'Total due',
  SES_SPLIT: 'Confirm Split',

  // Refill Screen
  RFS_ADD_ITEMS_TO_REFILL: 'Add items to refill',
  RFS_ADD: 'Add',
  RFS_ADD_TO_CARTS: 'Add to Cart',
  RFS_REFILL_REMOVE: 'Remove',
  RFS_REFILL: 'Refill',

  // Order Confirmation Screen
  OC_NEXT: 'Next',

  // Check Number Landing Screen
  CNS_CHECK_NUMBER: 'Check Number',
  CNS_SKIP_CHECK_IN: ' Skip check in',
  CNS_CHECK_NUMBER_NEXT: 'Check In',
  CNS_OK: 'OK',

  // Check Selection Screen
  CSS_CONTINUE: 'Continue',
  CSS_MORE_ITEMS: 'more items',
  CSS_SHOW_LESS: 'show less',
  // MY Check Screen
  MCS_MY_CHECK: 'My Check',
  MCS_REORDER: 'Reorder',
  MCS_CLICK_TO_PAY: 'CLICK TO PAY',

  // Text to check In
  TCLS_SPOT_NUMBER: 'Spot Number',
  TCLS_VEHICLE_TYPE: 'Vehicle Type',
  TCLS_VEHICLE_COLOR: 'Vehicle Color',
  TCLS_CONFIRM: 'Confirm',

  // Text to checkIn confirmation screen
  TCCS_CHANGE: 'Change',

  // Check Paid Screen
  CPS_RETRY: 'Retry',
  CPS_OK: 'OK',

  // Brand store locator
  ENTER_LOCATION: 'Enter Location',
  SEARCH_LOCATIONS: 'Search For Locations',
  VIEW_ALL_STORES: ' View all stores',

  // Table assignment
  EMP_RETRY: 'Retry',

  // Loyalty Wallet
  LWP_VALUE: 'Value:',
  LWP_START_DATE: 'Start date ',
  LWP_END_DATE: 'End date ',
  LWP_AVAILABLE_OFFER: 'Available Offers',

  // Brand store locator(SLLS)
  SLLS_ENTER_LOCATION: 'Enter Location',

  SLLS_SEARCH_LOCATIONS: 'Search For Locations',

  SLLS_VIEW_ALL_STORES: ' View all stores',

  // Brand store listing
  SLS_MILES: 'miles',
  SLS_VIEW_LOCATION: 'View location',
  SLS_HOURS: 'Hours',
  SLS_CURBSIDE: 'Curbside',
  SLS_WALKUP: 'Walkup',
  SLS_PICKUP: 'Pickup',
  SLS_DELIVERY: 'Delivery',
  SLS_NO_RESULTS: 'No Results Found',

  // Footer Screen
  FS_HOME: 'Home',
  FS_ORDERS: 'Order',
  FS_ORDER_INFO: 'Order Info',
  FS_CART: 'Cart',
  FS_MY_CHECK: 'My Check',
  FS_CALL_SERVER: 'Call Server',

  // Call Restaurant
  SRS_SUBTOTAL: 'Subtotal',
  SRS_CALL_RESTAURANT: 'Call Restaurant',
  SRS_RETRY_PAYMENT: 'Retry Payment',
  SRS_CONTINUE: 'Continue',
  SRS_SUBMIT_ORDER: 'Submit Order',

  // Waitlist screen
  WS_PHONE_NUMBER: 'Phone Number',
  WS_NAME: 'Name',
  WS_PARTY_SIZE: 'Party Size',
  WS_EMAIL_ADDRESS: 'Email Address (Optional)',
  WS_NOTE: 'Note (Optional)',
  WS_SUBMIT: 'Submit',
  WS_MODIFY: 'Modify',
  WS_YES: 'Yes',
  WS_NO: 'No',
  WS_UPDATE: 'Update',
  WS_EMAIL_INFO: 'Email',
  WS_NOTE_INFO: 'Note',
  WS_THANKYOU: 'Thank you',
  WS_CANCEL_RESERVATION: 'Cancel Reservation',

  // Order Summary Link
  OSL_ORDER_DETAILS: 'Order Details',
  OSL_STORE_NAME: 'Store Name',
  OSL_SPOT_SCREEN: 'Spot Screen',
  OSL_DATE_AND_TIME: 'Date and Time',
  OSL_NAME: 'Name',
  OSL_ORDER_NOTES: 'Order Notes',
  OSL_APARTMENT_SUITE: 'Apartment Suite',
  OSL_DELIVERY_ADDRESS: 'Delivery Address',
  OSL_VEHICLE_TYPE: 'Vehicle Type',
  OSL_VEHICLE_COLOR: 'Vehicle Color',
  OSL_BAG: 'Bag',
  OSL_SUB_TOTAL: 'Sub Total',
  OSL_PAYMENTS: 'Payments',
  OSL_TAX: 'Tax',
  OSL_TIP: 'Tip',
  OSL_TOTAL_DUE: 'Total Due',
  OSL_ORDER_SUMMARY: 'Order Summary',

  // Pay AT restauarnt
  PAS_PROCEED_ORDER_PLACED: 'If you continue, your order will be placed.',
  PAS_CANCEL: 'Cancel',
  PAS_CONFIRM: 'Confirm',
  PAS_STORE_INFORMATION: 'Store Information',
  PAS_VIEW_DIRECTIONS: 'View directions',
  PAS_THANK_YOU: 'Thank You',
};
